const unsortedSpecialties = [
  {
    name: 'Primary Care',
    shortName: 'primary-care',
    categoryShortName: 'primary-care',
    specialistName: 'Primary Care Doctors',
    description:
      'Primary Care is centered on lasting, caring relationships with patients and their families. Family physicians integrate the biological, clinical and behavioral sciences to provide continuing and comprehensive health care.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/family-medicine-175x175.png',
  },
  {
    name: 'Flu Shots',
    shortName: 'flu-shots',
    categoryShortName: ['primary-care', 'specialists'],
    specialistName: 'Flu Shot Specialists',
    description:
      'Every flu season is different, and influenza infection can affect people differently, but millions of people get the flu every year. An annual seasonal flu vaccine is the best way to help protect against flu. Vaccination has been shown to have many benefits including reducing the risk of flu illnesses, hospitalizations and even the risk of flu-related death in children.',
    extra: 'Source: Center for Disease Control',
    imageUrl: 'https://images.qwell.com/icons/vaccines-175x175.png',
  },
  {
    name: 'Obstetrics-Gynecology (OBGYN)',
    shortName: 'obgyn',
    categoryShortName: ['primary-care', 'specialists'],
    specialistName: 'Gynecologists',
    description:
      'An obstetrician-gynecologist is a healthcare professional that specializes in female reproductive health. People trained as OB-GYNs specialize in both obstetrics (working with pregnant women) and gynecology (treatment involving the female reproductive system).',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/obgyn-175x175.png',
  },
  {
    name: 'Ophthalmology',
    shortName: 'ophthalmology',
    categoryShortName: 'specialists',
    specialistName: 'Ophthalmologists',
    description:
      'Ophthalmologists are medical doctors who specialize in the care of vision and the eyes. Ophthalmologists are trained to diagnose and treat all eye diseases, perform eye surgery, and prescribe and fit eyeglasses and contact lenses to correct vision problems.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/ophthalmology-175x175.png',
  },
  {
    name: 'Dermatology',
    shortName: 'dermatology',
    categoryShortName: 'specialists',
    specialistName: 'Dermatologists',
    description:
      'A dermatologist is a physician who is trained to evaluate and treat children and adults with benign and malignant disorders of the skin, hair, nails and adjacent mucous membranes. Dermatologists also manage cosmetic disorders of the skin.',
    extra: 'Source: www.abderm.org',
    imageUrl: 'https://images.qwell.com/icons/dermatology-175x175.png',
  },
  {
    name: 'Physical Therapy',
    shortName: 'physical-therapy',
    categoryShortName: 'specialists',
    specialistName: 'Physical Therapists',
    description:
      'Physical therapists (PTs) optimize quality of life through prescribed exercise, hands-on care, and patient education. PTs teach patients how to prevent or manage their condition so that they will achieve long-term health benefits. PTs use treatment techniques to promote the ability to move, reduce pain, restore function, and prevent disability.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/physical-therapy-175x175.png',
  },
  {
    name: 'Otolaryngology (ent)',
    shortName: 'otolaryngology',
    categoryShortName: 'specialists',
    specialistName: 'Otolaryngologists',
    description:
      'Otolaryngologists (ENTs) are head and neck surgeons who specialize in treating you for issues of the ear, nose, or throat. ENT’s can do surgery and treat many different medical conditions.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/otolaryngology-175x175.png',
  },
  {
    name: 'Internal Medicine',
    shortName: 'internal-medicine',
    categoryShortName: 'primary-care',
    specialistName: 'Internists',
    description:
      'Internists are physicians specializing in internal medicine, a disciple focused on the care of adults. Internists are trained to prevent, diagnose, and treat diseases that affect adults.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/internal-medicine-175x175.png',
  },
  {
    name: 'Pediatrics',
    shortName: 'pediatrics',
    categoryShortName: 'primary-care',
    specialistName: 'Pediatricians',
    description:
      'Pediatricians are primary care doctors who manage the health of children, including physical, behavior, and mental health issues. They’re trained to diagnose and treat childhood illnesses, from minor health problems to serious diseases.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/pediatric-175x175.png',
  },
  {
    name: 'Podiatry',
    shortName: 'podiatry',
    categoryShortName: 'specialists',
    specialistName: 'Podiatrists',
    description:
      'A podiatrist is a doctor of podiatric medicine, a physician and surgeon who treats the foot, ankle, and related structures of the leg.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/podiatry-175x175.png',
  },
  {
    name: 'Gastroenterology',
    shortName: 'gastroenterology',
    categoryShortName: 'specialists',
    specialistName: 'Gastroenterologists',
    description:
      'Gastroenterology is an area of medicine that focuses on the health of the digestive system, or the gastrointestinal (GI) tract. A general gastroenterology doctor can treat you for stomach ulcers, acid reflux, irritable bowel, jaundice, hemorrhoids, bloody stool, pancreatitis, and perform screening tests for colon cancer.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/gastroenterology-175x175.png',
    conditionsUrl: 'https://qwell.com/gi-conditions-landing-page/',
    proceduresUrl: 'https://qwell.com/gi-procedures-landing-page/',
  },
  {
    name: 'Allergy',
    shortName: 'allergy',
    categoryShortName: 'specialists',
    specialistName: 'Allergists',
    description:
      'Whether it’s seasonal allergies or allergies to cats and dogs, if you have allergies you are not alone. Approximately 50 million Americans have allergy-related conditions. There are hundreds of ordinary substances, such as  pollens, molds, dust, and pets, that can trigger allergic reactions. See below for top recommended Allergists who can help you out when allergies get you down.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/allergy-175x175.png',
  },
  {
    name: 'Orthopedics',
    shortName: 'orthopedics',
    categoryShortName: 'specialists',
    specialistName: 'Orthopedists',
    description:
      'Orthopedics is the medical specialty that focuses on injuries and diseases of your body’s musculoskeletal system. This complex system, which includes your bones, joints, ligaments, tendons, muscles, and nerves, allows you to move, work, and be active.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/orthopedic-175x175.png',
  },
  {
    name: 'Dentistry',
    shortName: 'dentistry',
    categoryShortName: 'dentistry',
    specialistName: 'Dentists',
    description:
      'A branch of medicine that focuses on the diagnosis, prevention and treatment of conditions and disorders in the oral cavity and nearby structures. The latter includes the head, face, jaw, neck, tongue, and salivary glands.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/denistry-175x175.png',
  },
  {
    name: 'Nutrition',
    shortName: 'nutrition',
    categoryShortName: 'health-wellness',
    specialistName: 'Nutritionists',
    description:
      'Nutrition is important to keeping your body healthy and functioning at its best. Nutritionists can help patients with special needs, allergies, health problems, or a desire for increased energy. People desiring weight change may seek the care of a nutritionist for guidance on healthy diets.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/nutrition-175x175.png',
  },
  {
    name: 'Cardiology',
    shortName: 'cardiology',
    categoryShortName: 'specialists',
    specialistName: 'Cardiologists',
    description:
      'Cardiology is specialty of medicine in which physicians receive special training to find, treat, and prevent diseases of the heart and blood vessels. Cardiologists help people with heart disease return to a full and useful life. Cardiologists also counsel patients about the risks of heart disease and how to prevent it.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/cardiology-175x175.png',
  },
  {
    name: 'Psychiatry',
    shortName: 'psychiatry',
    categoryShortName: ['specialists', 'mental-health'],
    specialistName: 'Psychiatrists',
    description:
      'Psychiatry is the branch of medicine focused on the diagnosis, treatment, and prevention of mental, emotional, and behavioral disorders.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/pyschiatry-175x175.png',
    conditionsUrl: 'https://qwell.com/psychiatry/psychological-conditions/',
  },

  {
    name: 'Neurology',
    shortName: 'neurology',
    categoryShortName: 'specialists',
    specialistName: 'Neurologists',
    description:
      'A Neurologist is a doctor who specializes in treating diseases of the nervous system, which includes the brain and spinal cord.  Symptoms that commonly require a neurologist include: problems with coordination, weakness, changes in sensation, confusion, and dizziness.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/neurology-175x175.png',
  },
  {
    name: 'Integrative Medicine',
    shortName: 'integrative-medicine',
    categoryShortName: 'health-wellness',
    specialistName: ' Integrative Specialists',
    description:
      'Integrative medicine reaffirms the importance of the relationship between practitioner and patient, focuses on the whole person, and makes use of all appropriate therapeutic approaches, healthcare professionals, and disciplines to achieve optimal health and healing.',
    extra: 'Source: American Board of Physician Specialties',
    imageUrl: 'https://images.qwell.com/icons/integrated-medicine-175x175.png',
  },
  {
    name: 'Cosmetics',
    shortName: 'cosmetics',
    categoryShortName: 'health-wellness',
    specialistName: 'Cosmetic Specialists',
    description:
      'Cosmetic, or aesthetic, medicine is a developing subspecialty focused on improving the physical appearance through the use of minimally invasive  treatments. This field generally includes dermatology, reconstructive surgery and plastic surgery.',
    extra: 'Source: Aesthetic Anti-Aging Fellowship',
    imageUrl: 'https://images.qwell.com/icons/cosmetics-175x175.png',
  },
  {
    name: "Women's Health",
    shortName: 'womens-health',
    categoryShortName: 'health-wellness',
    description:
      'Women have many unique health concerns — menstrual cycles, pregnancy, birth control, menopause. While a number of health issues affect only women, others are more common or present differently in women. The broad expertise of women’s health professionals creates an environment of focused care for women. ',
    extra: 'Source: Harvard Health, Mayo Clinic',
    imageUrl: 'https://images.qwell.com/icons/womens-wellness-175x175.png',
  },
  {
    name: 'Urology',
    shortName: 'urology',
    categoryShortName: 'specialists',
    specialistName: 'Urologists',
    description:
      'Urology is a part of health care that deals with diseases of the urinary tract, including the kidneys, ureters, bladder, and urethra. Because they encounter a wide range of clinical issues, urologists have knowledge of internal medicine, pediatrics, gynecology, and many other parts of health care.',
    extra: 'Source: Urology Care Foundation',
    imageUrl: 'https://images.qwell.com/icons/urology-175x175.png',
  },
  {
    name: 'Endocrinology',
    shortName: 'endocrinology',
    categoryShortName: 'specialists',
    specialistName: 'Endocrinologists',
    description:
      'Endocrinology focuses both on the hormones and the many glands and tissues that produce them. Very small amounts of hormone can have a significant impact on the body. Hormones regulate metabolism, respiration, growth, reproduction, sensory perception, and movement. Hormone imbalances are the underlying reason for a wide range of medical conditions.',
    extra: 'Source: Medical News Today',
    imageUrl: 'https://images.qwell.com/icons/endocrinology-175x175.png',
  },
  {
    name: 'General Surgery & Sub-Specialties',
    shortName: 'surgery',
    categoryShortName: 'specialists',
    specialistName: 'General Surgeons',
    description:
      'Surgery is the specialty of medicine that treats diseases and disorders by cutting, removing, or changing the body with an operative procedure that opens the body for therapy. Surgery can mean a minor outpatient procedure, such as a carpal tunnel release, or may be a major procedure that treats life-threatening issues, such as a heart transplant.',
    extra: 'Source: Very Well Health',
    imageUrl: 'https://images.qwell.com/icons/surgery-175x175.png',
  },
  {
    name: 'Wellness',
    shortName: 'wellness',
    categoryShortName: 'health-wellness',
    description:
      'Wellness is an active process of becoming aware of and making choices toward a healthy and fulfilling life. Wellness is more than being free from illness, it is a dynamic process of change and growth. Maintaining an optimal level of wellness is absolutely crucial to live a higher quality life. ',
    extra: 'Source: UC Davis',
    imageUrl: 'https://images.qwell.com/icons/wellness-175x175.png',
  },
  {
    name: 'Hematology/Oncology',
    shortName: 'hematology',
    categoryShortName: 'specialists',
    specialistName: 'Hematologists',
    description:
      'Hematology is the study of blood health and diseases. It includes problems with the red blood cells, white blood cells, platelets, blood vessels, bone marrow, lymph nodes, spleen, and the proteins involved in bleeding and clotting. A doctor of hematology applies this specialized knowledge to treat patients with blood conditions.',
    extra: 'Source: American Society of Hematology',
    imageUrl: 'https://images.qwell.com/icons/hematology-175x175.png',
  },
  {
    name: 'Pain Management',
    shortName: 'anesthesiology',
    categoryShortName: 'specialists',
    specialistName: 'Pain Management Specialists',
    description:
      'An anesthesiologist is responsible for the patient’s safety and well being. This includes maintaining the patient in a state of controlled unconsciousness, providing pain relief, and monitoring critical life functions that are affected during procedures. A pain management specialist is trained in the evaluation, diagnosis, and treatment of all different types of pain. ',
    extra:
      'Source: American Society of Anesthesiologists; American Society of Regional Anesthesia and Pain Medicine',
    imageUrl: 'https://images.qwell.com/icons/pain-management-175x175.png',
  },
  {
    name: 'LGBTQ+ Care',
    shortName: 'lgbtq-care',
    categoryShortName: 'health-wellness',
    description:
      'People who are lesbian, gay, bisexual, or transgender (LGBT) are members of every community. They are diverse, come from all walks of life, and include people of all races and ethnicities, all ages, all socioeconomic statuses, and from all parts of the country. The perspectives and needs of LGBT people should be routinely considered in public health efforts to improve the overall health of every person and eliminate health disparities.',
    extra: 'Source: Centers for Disease Control and Prevention (cdc.gov)',
    imageUrl: 'https://images.qwell.com/icons/lgbtq-care-175x175.png',
  },
  {
    name: 'Rheumatology',
    shortName: 'rheumatology',
    categoryShortName: 'specialists',
    specialistName: 'Rheumatologists',
    description:
      'A rheumatologist is an internist who is trained in the diagnosis and treatment of musculoskeletal disease and autoimmune conditions commonly referred to as rheumatic diseases. These diseases can affect the joints, muscles, and bones causing pain, swelling, stiffness, and deformity.',
    extra: 'Source: American College of Rheumatolgy',
    imageUrl: 'https://images.qwell.com/icons/rheumatology-175x175.png',
  },
  {
    name: 'Radiology',
    shortName: 'radiology',
    categoryShortName: 'laboratory-radiology',
    specialistName: 'Radiologists',
    description:
      'Radiologists are medical doctors that specialize in diagnosing and treating injuries and diseases using medical imaging (radiology) procedures (exams/tests) such as X-rays, computed tomography (CT), magnetic resonance imaging (MRI), nuclear medicine, positron emission tomography (PET) and ultrasound.',
    extra: 'Source: American College of Radiology',
    imageUrl: 'https://images.qwell.com/icons/radiology-175x175.png',
  },
  {
    name: 'Travel Medicine',
    shortName: 'travel-medicine',
    categoryShortName: 'specialists',
    specialistName: ' Travel Medicine Specialists',
    description:
      'Travel medicine is a specialty that focuses on diseases and conditions that are acquired during travel. Travelers to different countries should be aware of the risk for acquiring diseases and injury which are not common in their own country. Immunizations, preventative medications, and general precautions should be considered prior to trips to different parts of the world.',
    extra: 'Source: MedicineNet',
    imageUrl: 'https://images.qwell.com/icons/travel-medicine-175x175.png',
  },
  {
    name: 'Weight Management',
    shortName: 'weight-management',
    categoryShortName: 'health-wellness',
    specialistName: 'Weight Management Specialists',
    description:
      'Obesity is a chronic condition that affects more than one in three adults and about 17 percent of children and adolescents in the United States. Being overweight or obese increases your risk of type 2 diabetes, heart disease, stroke, fatty liver disease, kidney disease, and other health issues. If you are struggling with your weight, you may find one of our Weight Loss Doctors helpful.',
    extra:
      'Source: The National Institute of Diabetes and Digestive and Kidney Diseases Health Information Center',
    imageUrl: 'https://images.qwell.com/icons/weight-management-175x175.png',
  },
  {
    name: 'Physical Medicine & Rehabilitation',
    shortName: 'physical-medicine',
    categoryShortName: 'specialists',
    specialistName: 'Physiatrists',
    description:
      'Physical Medicine and Rehabilitation (PM&R), also known as physiatry, is a medical specialty that involves restoring function for a person who has been disabled as a result of a disease, disorder, or injury. Physiatry provides integrated, multidisciplinary care aimed at recovery of the whole person by addressing the individual’s physical, emotional, medical, vocational, and social needs. ',
    extra: 'Source: John Hopkins Medicine',
    imageUrl: 'https://images.qwell.com/icons/physiatry-175x175.png',
  },
  {
    name: 'Sports Medicine',
    shortName: 'sports-medicine',
    categoryShortName: 'specialists',
    specialistName: 'Sports Specialists',
    description:
      'Sports medicine or sport medicine is an interdisciplinary subspecialty of medicine which deals with the treatment and preventive care of athletes, both amateur and professional. The sports medicine “team:” includes specialty physicians and surgeons, athletic trainers, physical therapists, coaches, other personnel, and, of course, the athlete.',
    extra: 'Source: Wikipedia',
    imageUrl: 'https://images.qwell.com/icons/sports-medicine-175x175.png',
  },
  {
    name: 'Vascular Surgery & Vein Specialists',
    shortName: 'vascular-surgery',
    categoryShortName: 'specialists',
    specialistName: 'Vascular Surgeons',
    description:
      'Vascular surgeons are specialists who are highly trained to treat diseases of the vascular system. Your blood vessels –arteries carrying oxygen-rich blood and veins carrying blood back to the heart — are the roadways of your circulatory system. Without smoothly flowing blood, your body cannot function. Conditions such as hardening of the arteries can create “traffic jams” in your circulatory system, obstructing the flow of blood to any part of the body.',
    extra: 'Source: Society of Vascular Surgery',
    imageUrl: 'https://images.qwell.com/icons/surgery-175x175.png',
  },
  {
    name: 'Neurosurgery',
    shortName: 'neurosurgery',
    categoryShortName: ['specialists', 'mental-health'],
    specialistName: 'Neurosurgeons',
    description:
      'Neurosurgery, or neurological surgery, is the medical specialty concerned with the prevention, diagnosis, surgical treatment, and rehabilitation of disorders which affect any portion of the nervous system including the brain, spinal cord, peripheral nerves, and extra-cranial cerebrovascular system.',
    extra: 'Source: Wikipedia',
    imageUrl: 'https://images.qwell.com/icons/neurology-175x175.png',
  },
  {
    name: 'Sleep Medicine',
    shortName: 'sleep-medicine',
    categoryShortName: 'specialists',
    specialistName: 'Sleep Medicine Specialists',
    description:
      'Sleep medicine experts, including doctors trained in conditions of lungs and breathing, brain and nervous system, and mental health, have experience diagnosing and treating people with sleep disorders. Sleep specialists may also work with ENTs, pediatricians, cardiologists, dentists, oral and maxillofacial surgeons, and others to evaluate and treat your condition.',
    extra: 'Source: Mayo Clinic',
    imageUrl: 'https://images.qwell.com/icons/sleep-medicine-175x175.png',
  },
  {
    name: 'Nephrology',
    shortName: 'nephrology',
    categoryShortName: 'specialists',
    specialistName: 'Nephrologists',
    description:
      'Nephrology is the subspecialty of internal medicine that focuses on the diagnosis and treatment of diseases of the kidney. Because the kidney performs so many critical functions, nephrologists maintain expertise in primary kidney disorders, but also the management of the systemic consequences of kidney dysfunction. ',
    extra: 'Source: American College of Physicians',
    imageUrl: 'https://images.qwell.com/icons/nephrology-175x175.png',
  },
  {
    name: 'Urgent Care',
    shortName: 'urgent-care',
    categoryShortName: 'specialists',
    description:
      'A critical link between primary care physicians and the emergency room, providing care without waiting, for a wide range of conditions.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/urgent-care-175x175.png',
  },
  {
    name: 'Pulmonology',
    shortName: 'pulmonology',
    categoryShortName: 'specialists',
    specialistName: 'Pulmonologists',
    description:
      'Pulmonology is specialty of internal medicine foucsed on diagnosis, treatment, and management of condtions involving the lung and respiratory system. ',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/pulmonolgy-175x175.png',
  },
  {
    name: 'Laboratory Services',
    shortName: 'labs',
    categoryShortName: 'laboratory-radiology',
    specialistName: 'Labs',
    description:
      'Laboratory services are tests that are carried out on clinical specimens, such as blood, urine, or tissue to obtain information about the health of patients. These laboratory services may be recommended by your Primary Care Provider or other specialist to aid in the diagnosis, treatment, or prevention of diseases.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/labs-175x175.png',
  },
  {
    name: 'Chiropractic',
    shortName: 'chiropractor',
    categoryShortName: 'health-wellness',
    specialistName: 'Chiropractors',
    description:
      "Chiropractors are health professionals who specialize in treating you for health problems of the neuromusculoskeletal system, which includes nerves, bones, muscles, ligaments, and tendons. They use spinal adjustments, manipulation, and other techniques to manage patients' health concerns, such as back and neck pain.",
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/chiropractor-175x175.png',
  },
  {
    name: 'Therapists',
    shortName: 'therapy',
    categoryShortName: ['health-wellness', 'mental-health'],
    specialistName: 'Therapists',
    description:
      'A psychotherapist is a trained professional who assists those who are suffering with stress, anxiety, depression, bipolar disorder, negative behavior patterns, debilitating feelings, and various other psychological conditions.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/wellness-175x175.png',
  },
  {
    name: 'Massage Therapy',
    shortName: 'massage-therapy',
    categoryShortName: 'health-wellness',
    specialistName: 'Massage Therapist',
    description:
      'Massage therapy is a type of treatment in which a trained medical professional manipulates the soft tissues of your body using varying degrees of pressure and movement. Massage is considered part of integrative medicine and is increasingly being offered along with standard treatment for a wide range of medical conditions and situations.',
    extra: '',
    imageUrl: 'https://images.qwell.com/icons/massage-therapy175x175.jpg',
  },
];

const specialties = unsortedSpecialties.sort((a, b) => {
  if (a.shortName < b.shortName) {
    return -1;
  }
  if (a.shortName > b.shortName) {
    return 1;
  }
  return 0;
});

const findSpecialtyFromShortName = shortName => {
  return specialties.find(specialty => specialty.shortName === shortName) || {};
};

module.exports = {
  specialties,
  findSpecialtyFromShortName,
};
